import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesAdmin() {
  const { user } = useContext(AuthContext);
  const SECCIONES = [
    { section: "Ventas", items: [
      { label: "Ventas", icon: "fas fa-money-bill-wave", color: "#10b981", href: "/ListadoVentas", desc: "Listado de ventas", enabled: !!user.menu_ventas },
      { label: "Ventas Sin Evidencia", icon: "fas fa-ban", color: "#ef4444", href: "/ListadoVentasNoEvidencia", desc: "Sin comprobante", enabled: !!user.menu_ventas },
      { label: "Comisiones", icon: "fas fa-percentage", color: "#f59e0b", href: "/ListadoComisiones", desc: "Comisiones vendedor", enabled: !!user.comisiones },
    ]},
    { section: "Cobranza", items: [
      { label: "Anticipos", icon: "fas fa-hand-holding-usd", color: "#06b6d4", href: "/ListadoAnticipos", desc: "Anticipos clientes", enabled: !!user.menuAnticipos },
      { label: "Abonos", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ListadoAbonos", desc: "Pagos recibidos", enabled: !!user.abonos },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#ef4444", href: "/ListadoDevolucionesAdmin", desc: "Devoluciones", enabled: !!user.menu_devolucionesAdmin },
      { label: "Estado Cuenta", icon: "fas fa-file-invoice-dollar", color: "#6366f1", href: "/EstadoCuenta", desc: "Saldos clientes", enabled: !!user.edoCtaClientes },
      { label: "Estado Cuenta Vendedores", icon: "fas fa-list-ul", color: "#8b5cf6", href: "/EstadoCuentaVendedores", desc: "Saldos vendedores", enabled: !!user.estado_cuenta_vendedores },
    ]},
    { section: "Bancos y Tesoreria", items: [
      { label: "Bancos", icon: "fas fa-university", color: "#3b82f6", href: "/Bancos", desc: "Cuentas bancarias", enabled: !!user.bancos },
      { label: "Movimientos Bancos", icon: "fas fa-list-ol", color: "#06b6d4", href: "/MovimientosBancos", desc: "Movimientos", enabled: !!user.bancos },
      { label: "Traspaso Dinero", icon: "fas fa-dollar-sign", color: "#14b8a6", href: "/ListadoTraspasosDinero", desc: "Traspasos internos", enabled: !!user.gastosTiendas },
      { label: "Empresas", icon: "fas fa-industry", color: "#64748b", href: "/Empresas", desc: "Catalogo empresas", enabled: !!user.bancos },
    ]},
  ];
  return (
    <MenuBotones titulo="Administracion" descripcion="Ventas, cobranza, bancos y tesoreria" icono="fas fa-briefcase" color="#3b82f6" secciones={SECCIONES} />
  );
}

export default BotonesAdmin;
